import { render, staticRenderFns } from "./adChannels.vue?vue&type=template&id=23253f56&"
import script from "./adChannels.vue?vue&type=script&lang=js&"
export * from "./adChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23253f56')) {
      api.createRecord('23253f56', component.options)
    } else {
      api.reload('23253f56', component.options)
    }
    module.hot.accept("./adChannels.vue?vue&type=template&id=23253f56&", function () {
      api.rerender('23253f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/adChannels.vue"
export default component.exports